
<template>
  <v-layout row>
    <v-dialog v-model="cancelClass.dialog"
              max-width="600px">
        <v-card>
          <v-card-title class="title blue-title pa-3 pt-4 ml-2">
            Cancel Reason
            <div class="header-close" title="close" @click="cancelClass.dialog = false">
              <v-icon>close</v-icon>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form ref="forms">
            <v-container grid-list-md pa-0 px-2>
              <v-layout wrap>
                <v-flex xs12>
                  <v-flex xs12>
                      <v-subheader class="pa-0 form-title">Are you sure to cancel the course?</v-subheader>
                  </v-flex>
                  <v-textarea v-model="cancelText"
                              outline
                              single-line 
                              :rules="textRule"
                              counter="100"
                              maxLength="100"
                              ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-layout justify-center>
              <v-btn class="text-none red-button dialog-submit"
                @click="submit">Confirm</v-btn>
              <v-btn class="text-none cancel-button"
                  @click="cancelClass.dialog = false">Cancel</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { updateTrainClassStatus } from '@/api/teachinfo'
export default {
    name: 'cancelClass',
    props: {
        cancelClass: {
            dialog: false,
            id:0
        }
    },
    data:()=>({
        textRule: [
            v => !!v || 'Required.',
            v => (v && v.length <= 100) || 'The maximum number of input characters has been reached.'
        ],
        cancelText:''
    }),
    methods:{
        submit(){
            if (!this.$refs.forms.validate()) {
                return
            }
            updateTrainClassStatus(this.cancelClass.id,this.cancelText).then(res => {
                let type = res.data.ErrorCode === 0 ? 'success' : 'error'
                this.$root.$alertTips(res.data.Msg, type).then(() => {
                    if (res.data.ErrorCode === 0) {
                        this.cancelClass.dialog = false;
                        this.$emit('func',true)
                    }
                })
            })
        }
    },
    watch: {
        'cancelClass.dialog': function (value, oldValue) { // 表单里的v-model如果使用props的数据会在弹层时就验证;去掉校验信息
            if (value !== oldValue) {
                this.$refs.forms.resetValidation()
            }
        },
        'cancelClass.id':function(value, oldValue){
          if (value !== oldValue) {
              this.cancelText=''
          }
        }
    }
}
</script>